__turbopack_context__.v({
  "badgeIcon": "styles-module__zINzcG__badgeIcon",
  "linkContainer": "styles-module__zINzcG__linkContainer",
});
